export default __webpack_public_path__ + "static/media/img0.9ec9d33b.png";